import {RadioGroup, TextInput} from "omoplay";
import React, {useEffect, useState} from "react";


const RouletteGenerateForm = ({onPrompt}) => {
    const [rouletteForm, setRouletteForm] = useState({
        size: 3,
        backgroundColor: "#000000",
        textColor: "#FFFFFF",
        adjacentColor: "#E6C08D",
        adjacentTextColor: "#000000",
        benefitNames: "오모플레이 교환권,테스트 10만원 쿠폰,온라인 10% 할인쿠폰"
    })

    useEffect(() => {
        onPrompt(`정면에서 내려다본 원형 한국어 경품 룰렛 휠을 그려 주세요.
                  룰렛은 정확히 완벽한 원이어야 하고, ${rouletteForm.size}개의 동일한 크기의 조각(파이 형태)으로 나뉘어 있습니다.
                  12시 방향부터 시계방향으로 배경색은 ${rouletteForm.backgroundColor} 이고 글자색은 ${rouletteForm.textColor}으로 시작해 그다음 배경색은 ${rouletteForm.adjacentColor} 이고 글자색은 ${rouletteForm.adjacentTextColor}
                  이런식으로 12시 방향까지 배경색을 번갈아 채웁니다.
                  다음과 같은 텍스트가 12시 방향부터 시계방향으로 배치됩니다: ${rouletteForm.benefitNames}
                  각 조각은 얇은 금색 선으로 구분되어야 하며, 전체 룰렛의 바깥 테두리는 두꺼운 검정색이고, 안쪽에 얇은 금색 띠가 한 겹 더 둘러져 있어야 합니다.
                  룰렛에는 화살표나 추가 장식 없이 전체적으로 미니멀한 스타일을 유지해 주세요. 각 텍스트는 조각의 중앙에 잘 보이게 배치해 주세요.
                  스타일은 깔끔한 벡터 스타일 또는 플랫 디자인으로 그려 주세요.
                  룰렛이 아닌 배경은 투명하게 처리 하세요.`
        )
    }, [rouletteForm])

    return (
        <div className="flex-col gap-4">
            <div className="text-[20px] font-semibold">템플릿을 선택 하세요</div>
            <RadioGroup items={[
                { label: (<img alt="preview_coupon"
                               src="https://img.headless.co.kr/offline_qr_service/7/d19aeab3-e407-42d0-b18a-7aa24863a77e"
                               width="100px" />
                    ), value: "black"}
            ]} onSelected={(items) => console.log(items)} />
            <div className="text-[20px] font-semibold">당첨 혜택 개수</div>
            <TextInput type="number" value={rouletteForm.size} max={9}
                       onChange={(e) => setRouletteForm((prev) => {
                           return { ...prev, size: e.target.value}
                       })}
            />
            <div className="text-[20px] font-semibold">당첨 혜택명(반드시 쉼표로 구분하세요)</div>
            <TextInput value={rouletteForm.benefitNames}
                       onChange={(e) => setRouletteForm((prev) => {
                           return { ...prev, benefitNames: e.target.value}
                       })}
            />
            <div className="text-[20px] font-semibold">메인 배경 색상</div>
            <div className="flex-align-center gap-4">
                글자 색상: <input type="color" value={rouletteForm.textColor}
                              onChange={(e) => setRouletteForm((prev) => {
                                  return { ...prev, textColor: e.target.value}
                              })} />
                배경 색상: <input type="color" value={rouletteForm.backgroundColor}
                              onChange={(e) => setRouletteForm((prev) => {
                                  return { ...prev, backgroundColor: e.target.value}
                              })} />
            </div>
            <div className="text-[20px] font-semibold">인접 배경 색상</div>
            <div className="flex-align-center gap-4">
                글자 색상: <input type="color" value={rouletteForm.adjacentTextColor}
                              onChange={(e) => setRouletteForm((prev) => {
                                  return { ...prev, adjacentTextColor: e.target.value}
                              })} />
                배경 색상: <input type="color" value={rouletteForm.adjacentColor}
                              onChange={(e) => setRouletteForm((prev) => {
                                  return { ...prev, adjacentColor: e.target.value}
                              })} />
            </div>
        </div>
    )
}

export default RouletteGenerateForm